var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('CGoogleLoginButton',{on:{"login":function($event){return _vm.onLogin('google', $event)}}}),_c('CAppleLoginButton',{on:{"login":function($event){return _vm.onLogin('apple', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }